/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 0.0.1
 */

/**
 * Species
 */
export type CreateReportDtoSpecie =
  (typeof CreateReportDtoSpecie)[keyof typeof CreateReportDtoSpecie];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateReportDtoSpecie = {
  canisLupus: 'canisLupus',
  bosTaurus: 'bosTaurus',
  susScrofa: 'susScrofa',
  anasPlatyrhynchos: 'anasPlatyrhynchos',
  apisMellifera: 'apisMellifera',
} as const;
